module.exports = __webpack_public_path__ + "static/img/pro4.df47b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro4.png
// module id = Pgyn
// module chunks = 0